import useNotification from '../../../Hooks/useNotification.hook';
import useTranslation from '../../../Hooks/useTranslation';

export default function useRestApiClient() {
	const { showNotificationAlert } = useNotification();
	const { t } = useTranslation();

	const processResult = (
		result: {
			data: any;
			status: number | undefined;
			statusText: string | undefined;
		},
		callback: () => void,
	) => {
		if (result.status === 200) {
			callback();
		} else {
			showNotificationAlert({
				content: t('base.shared.warningBug'),
			});
		}
	};

	return { processResult };
}
